// extracted by mini-css-extract-plugin
module.exports = {"heading":"Terms_heading__2deE2","heading2":"Terms_heading2__2wQUr","list":"Terms_list__1xrFh"};